import { useState } from 'react';
import { useImportContactsMutation } from '@/store/query/contacts-list';
import { BulkError } from '@/components/ats';
import { useDisclosure, Text } from '@chakra-ui/react';
import { useGetAllJobsQuery } from '@/store/query/ats-jobs';
import { FormBuilder } from '@/components/formBuilder';
import { Box } from '@chakra-ui/react';
import { JobListMenu } from '@/components/ats/filters/components/UiItems/JobList';

export const PostModalForm = ({
  modalClose = () => {},
  candidateId,
  isBulk,
  formRef,
  enableStageOption = false,
  ...props
}) => {
  const [stageOptions, setStageOptions] = useState([]);

  const { data: ats_jobs = [], isLoading: isJobsOptionsLoading } =
    useGetAllJobsQuery({
      params: {
        view: 'interview_plan',
        scope: 'viewable',
        filter_by: { job_statuses: ['published', 'scheduled'] },
        sort_by: { open_at: 'DESC' },
        limit: 500,
      },
    });

  //eslint-disable-next-line
  const [errorContacts, setErrorContacts] = useState();
  const errorsActions = useDisclosure();

  const formConfig = [
    {
      name: 'job_id',
      label: 'Select a job',
      type: 'select',
      options: ats_jobs?.map((job) => ({
        value: job?.id,
        label: job?.name,
        status: job?.state || 'published',
        department: job?.department,
        locations: job?.offices || [],
        ...job,
      })),
      isLoading: isJobsOptionsLoading,
      components: {
        Menu: JobListMenu,
        IndicatorSeparator: () => null,
      },
      newStyles: [
        {
          type: 'menu',
          newStyles: {
            padding: '0px !important',
            borderRadius: '6px !important',
            border: '1px solid #EDEDED',
            borderColor: 'border-color',
            boxShadow: 'none',
          },
        },
      ],
      customOnChange: (value) => {
        const stages = value.stages;
        setStageOptions(stages);
      },
    },

    {
      name: 'interested_ats_job_stage_id',
      label: 'Interview Stage',
      type: 'select',
      options: stageOptions,
      isLoading: isJobsOptionsLoading,
      valueKey: 'id',
      labelKey: 'name',
    },
  ];
  //eslint-disable-next-line
  const [importContact] = useImportContactsMutation();

  const handleSubmit = async (values) => {
    const { job_id, stage_id } = values;
    const selectedJob = ats_jobs?.find((job) => job?.id === job_id);
    const selectedStageId =
      selectedJob?.stages?.find(
        (stage) => stage?.name === 'Application Review' && stage?.position === 2
      )?.id || selectedJob?.stages?.[0]?.id;

    //eslint-disable-next-line
    const payload = {
      ats_job_id: selectedJob?.id,
      ats_job_stage_id: enableStageOption ? stage_id : selectedStageId,
      contact_ids: isBulk ? candidateId : [candidateId],
    };
  };

  return (
    <Box mb="400px" mt="12px">
      <Box h="70px" background={'ats-bg-primary'} borderRadius={'sm'}>
        <Text fontSize="sm" p={'lg'}>
          <strong>Note: </strong> All candidates marked as
          <strong> Good fit</strong> will automatically be sent to the selected
          job and stage
        </Text>
      </Box>
      <FormBuilder
        config={formConfig}
        onSubmit={handleSubmit}
        formRef={formRef || props?.formRef}
      />
      {errorsActions?.isOpen && (
        <BulkError
          total={candidateId?.length}
          contacts={errorContacts}
          modalActions={errorsActions}
          mainText={`Candidate action${
            errorContacts?.length > 1 ? 's' : ''
          } failed`}
          successMessage="successfully added to job"
          onActionSubmit={(close) => {
            modalClose();
            close();
          }}
          mainSubText={
            errorContacts?.length > 1
              ? `These candidates are already present in the specified job, so this action is not completed.`
              : `This candidate is already present in the specified job, so this action is not completed.`
          }
        />
      )}
    </Box>
  );
};
